import { APIClient } from "./apiCore";
import * as url from "./urls";
import { Utils } from "../helpers/utils";
import { MemberRole, TaskStatus, WpEmpFilterType, WpFilterTaskDueMode } from "../../src/redux/workplace/wpTypes"
import { WpModes, WpSortMode } from "../constants";
import { SavePostInfoParm } from "types";

const api = new APIClient();

export const loadPostTitleApiV2 = (wpMode: WpModes, keyword: string, tagSet: string[], memberRole: MemberRole, tagIds: number[] | null, filterUnRead: boolean, filterNotClose: boolean, empFilterType: WpEmpFilterType/*includeFilterEmpRelated: boolean | null*/
  , includePostIds: string[] | null, tagCatMatchedAll?: string[] | null, callFrom?: string, taskStatus?: TaskStatus[] | null
  , filterFromDash?: boolean | null, taskResponder?: number | null, taskAssigner?: any | null, taskRequester?: any | null
  , taskRange1?: Date | null, taskRange2?: Date | null, includeTaskRecurance?: boolean | null
  , filterTaskDueMode?: WpFilterTaskDueMode | null
  , sortMode?: WpSortMode | null
) => {

  // backend TaskSort enum: RecentPost = 0, DueDate = 1 - sent by name so it doesn't depend on the frontend enum's numbering
  const sortModeArg = sortMode == null ? null : (sortMode == WpSortMode.DueDate ? "DueDate" : "RecentPost");

  const arg = {
    wpMode, keyword, tagSet, memberRole, tagIds: tagIds, filterUnRead: filterUnRead, filterNotClose: filterNotClose, empFilterType/*includeFilterEmpRelated*/, includePostIds, tagCatMatchedAll, taskStatus
    , filterFromDash, taskResponder, taskAssigner, taskRequester
    , taskRange1, taskRange2, includeTaskRecurance
    , filterTaskDueMode
    , sortMode: sortModeArg
  };
  // console.log(`loadPostTitleApi(${callFrom}):`, arg);
  return api.fnPostForm(url.WP_LOAD_POST_TITLE_V2, arg);
}

export const loadPostConverApi = (mode: WpModes, postId: string) => {
  return api.fnPostForm(url.WP_LOAD_POST_CONVER2, { mode, postId });
}

export const loadPostConverApi2 = (mode: WpModes, postId: string, beforePostDateTime?: Date | null, beforePostId?: string | null, limit?: number) => {
  return api.fnPostForm(url.WP_LOAD_POST_CONVER3, { mode, postId, beforePostDateTime, beforePostId, limit });
}

export const loadPostInfoApi = (postId: string) => {
  // return api.fnPostForm(url.WP_LOAD_POST_INFO2, { wpMode, postId });
  return api.fnPostForm(url.WP_LOAD_POST_INFO3, { postId });
}

export const updateReadApi = (postIdParent: string) => {
  return api.fnPostForm(url.WP_UPDATE_READ, { postIdParent });
}

export const updateReadMultiApi = (postIdParent: string) => {
  return api.fnPostForm(url.WP_UPDATE_READ_MULTI, { postIdParent });
}

export const getRoleUnreadCountApi = (sendNotification: boolean) => {
  return api.fnPost(url.WP_GET_ROLE_UNREAD_COUNT, { sendNotification });
}

export const loadDllEmployeeApi = () => {
  return api.fnPost(url.GET_DLL_VALUE_USER, {});
}

export const loadTaskDashApiV2 = (statusRange1: Date | null, statusRange2: Date | null, filterTagId: number | null, includeTaskRecurance?: boolean | null) => {
  return api.fnPostForm(url.WP_LOAD_TASK_DASH_V2, { statusRange1, statusRange2, filterTagId, includeTaskRecurance });
}

export const loadTaskDashboardByDivApi = (divMode: "DIV_RSP" | "DIV_ASG" | "DIV_REQ", statusRange1: Date | null, statusRange2: Date | null, filterTagId: number | null, includeTaskRecurance?: boolean | null) => {
  return api.fnPostForm(url.WP_LOAD_TASK_DASHBOARD_BY_DIV, { divMode, statusRange1, statusRange2, filterTagId, includeTaskRecurance });
}

export const loadTaskDashTagsApiV2 = (includeTaskRecurance?: boolean | null) => {
  return api.fnPostForm(url.WP_LOAD_TASK_DASH_TAGS_V2, { includeTaskRecurance });
}

export const loadTaskDashStatusrangeV2Api = (statusRange1: Date | null, statusRange2: Date | null, filterTagId: number | null, includeTaskRecurance?: boolean | null) => {
  return api.fnPostForm(url.WP_LOAD_TASK_DASH_STATUSRANGE_V2, { statusRange1, statusRange2, filterTagId, includeTaskRecurance });
}

export const loadTaskDashRecuranceApi = () => {
  return api.fnPostForm(url.WP_SEARCH_TASK_RECURANCE, { forDash: true });
}

export const savePostInfo = async (parm: SavePostInfoParm) => {
  return api.fnPostBody(url.WP_SAVE_POST_INFO, parm);
}

export const loadSubTaskApi = async (parentTaskId: string) => {
  return api.fnPostForm(url.WP_LOAD_SUB_TASK, { parentTaskId });
}

export const tagMasterCatLoadApi = async () => {
  return api.fnPostForm(url.WP_TAG_MASTER_CAT_LOAD, {});
}

